import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { persistBrowseName, pushEvent } from '../../../utils/dataLayer';

export default class CountryListAr extends React.Component {
    state = {
        countries: [],
        loading: true,
    }

    handleCountryClick = (country) => {
        this.setState({loadinng: true});
        localStorage.setItem('language', 'ar');
        localStorage.setItem('country_id', country.id);
        persistBrowseName('country_name', country.name);
        localStorage.removeItem('dealer_id');
        localStorage.removeItem('dealer_name');
        // localStorage.removeItem('cart');
        document.documentElement.lang = 'ar';
        document.documentElement.dir = 'rtl';
        pushEvent('site_country_selected', {
            country_id: country.id,
            country_name: country.name,
            ui_source: 'list',
        });
        pushEvent('site_language_changed', { language: 'ar' });
        
        const existingLink = document.getElementById('bootstrap-stylesheet');
        if (existingLink) {
            existingLink.remove();
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.id = 'bootstrap-stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.rtl.min.css';
        document.head.appendChild(link);
        this.setState({loading: false});
        
    }

   
    componentDidMount() {
        this._isMounted = true;
        this.setState({ loading: true });
        const token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
        const config = { headers: { 'Authorization': token, 'X-Locale': 'ar' } };
        axios.get(
            process.env.REACT_APP_FORD_API_URL + '/api/v1/countries/filter?market_id=' + process.env.REACT_APP_MARKET_ID + '&brand_id=' + process.env.REACT_APP_BRAND_ID,
            config
        )
            .then(res => {
                if (this._isMounted) this.setState({ countries: res.data.data, loading: false });
            })
            .catch(error => {
                if (this._isMounted) this.setState({ loading: false });
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        
        const { countries, loading } = this.state;
        
        return (
            <>
            {loading &&
                <div className="loader-container">
                    <div className="loader"><img src='../images/Rolling@1x-1.0s-200px-200px.gif' width={100} height={100}/></div>
                </div>
            }
            <ul>
            {!loading && countries.length && 
                    countries.map
                    (
                        country => <li key={country.id}><Link to="/dealer" onClick={() => this.handleCountryClick(country)}>{country.name}</Link></li> 
                    )
                }
            </ul>
        </>
        )
    }
}